import { useEffect } from 'react'

// Mengunci scroll halaman selama sebuah modal/overlay terbuka.
//
// KENAPA TIDAK CUKUP `document.body.style.overflow = 'hidden'`:
// Di aplikasi ini elemen yang men-scroll adalah <html> (document.scrollingElement === html)
// dan `html` tidak punya overflow non-visible, jadi overflow milik <body> TIDAK merambat ke
// viewport. Sudah diuji di browser: dengan body overflow:hidden, window.scrollTo(0, 3000)
// tetap menggeser halaman ke 3000.
//
// Mengunci <html> juga bisa, tapi mengubah overflow <html> membuat posisi scroll ter-reset
// ke 0 (terbukti di uji yang sama) — halaman melompat ke atas saat modal dibuka dan tetap
// di atas setelah ditutup.
//
// Karena itu dipakai teknik `position: fixed` pada body: posisi scroll disimpan dulu, body
// digeser ke atas sebesar posisi tsb supaya tampilannya tidak berubah, lalu dikembalikan
// persis saat modal ditutup.
export default function useBodyScrollLock(isLocked) {
   useEffect(() => {
      if (!isLocked) return

      const scrollY = window.scrollY
      const { style } = document.body
      const previous = {
         position: style.position,
         top: style.top,
         left: style.left,
         right: style.right,
         width: style.width,
         overflow: style.overflow
      }

      style.position = 'fixed'
      style.top = `-${scrollY}px`
      style.left = '0'
      style.right = '0'
      style.width = '100%'
      style.overflow = 'hidden'

      return () => {
         Object.assign(style, previous)
         // Kembalikan ke posisi semula; tanpa ini halaman melompat ke paling atas.
         window.scrollTo(0, scrollY)
      }
   }, [isLocked])
}
